import React from 'react'
import PropTypes from 'prop-types'
import ReactMarkdown from 'react-markdown'
// MUI Components
import { ListItem, ListItemText, ListItemAvatar, Divider, Avatar, Typography } from '@mui/material'
// custom imports
import i4sLogo from '..//assets/images/I4S_logo_circ.png'
import p4pLogo from '..//assets/images/P4P_logo_circ.png'

const ChatMessage = ({ uniqueId, content, role, secondaryText }) => {
  // determine faction of player

  // Determine user logo
  const userLogo = i4sLogo

  // Determine avatar properties based on the role
  const avatarProps = role === 'user'
    ? {
        alt: 'User Logo',
        src: userLogo
      }
    : {
        alt: 'Peace Game Logo',
        src: p4pLogo
      }

  return (
    <div>
      <ListItem key={uniqueId}>
        <ListItemAvatar>
          <Avatar sx={{ objectFit: 'scale-down' }} {...avatarProps} />
        </ListItemAvatar>
        <ListItemText
          align="left"
          primary={
          <Typography component="div">
            <ReactMarkdown>
              {content}
            </ReactMarkdown>
          </Typography>
          }
          secondary={ secondaryText }
          style={{ wordBreak: 'break-word', maxWidth: '100%' }}
        />
      </ListItem>
      <Divider />
    </div>
  )
}

ChatMessage.propTypes = {
  uniqueId: PropTypes.number.isRequired,
  content: PropTypes.string.isRequired,
  email: PropTypes.string,
  role: PropTypes.string,
  playerName: PropTypes.string,
  playerFaction: PropTypes.string,
  messageType: PropTypes.string,
  secondaryText: PropTypes.string
}

export default ChatMessage
